import { useCallback, useEffect, useMemo, useState } from "react";
import { Box, Tab, Tabs, Typography, useTheme } from "@mui/material";
import { useSearchParams } from "react-router-dom";
import { useSelector } from "react-redux";

import DocumentUpload from "./DocumentUpload";
import BulkUploadStatusHistory from "./BulkUploadStatusHistory";

import { userModule } from "constants";

import { bulkUploadTabs } from "./contants";

const TabPanel = ({ children, value, selectedTab, tabName, ...rest }) => {
  return (
    <Box
      role="tab-panel"
      hidden={value !== selectedTab}
      id={`tab-panel-${value}`}
      aria-labelledby={`tab-${value}`}
      {...rest}
    >
      {value === selectedTab && <>{children}</>}
    </Box>
  );
};

const BulkUpload = () => {
  const theme = useTheme();
  const [searchParams, setSearchParams] = useSearchParams();
  const currentTab = searchParams.get("tab");
  const userModules = useSelector((state) => state.userData.modules);
  const [tab, setTab] = useState(currentTab ?? bulkUploadTabs.DOCUMENT_UPLOAD);

  //verify user access for document upload
  const hasBulkUploadAccess = useMemo(
    () => userModules?.some(({ name }) => name === userModule.documentUpload),
    [userModules],
  );

  const hasBulkUploadStatusHistoryAccess = useMemo(
    () =>
      userModules?.some(
        ({ name }) => name === userModule.bulkUploadStatusHistory,
      ),
    [userModules],
  );

  useEffect(() => {
    if (!searchParams.get("tab")) {
      searchParams.set("tab", bulkUploadTabs.DOCUMENT_UPLOAD);
      setSearchParams(searchParams);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleUpdateQueryParam = useCallback(
    (tab) => {
      searchParams.set("tab", tab);
      setSearchParams(searchParams);
    },
    [searchParams, setSearchParams],
  );

  const handleTabChange = (_event, newValue) => {
    setTab(newValue);
    handleUpdateQueryParam(newValue);
  };

  return (
    <Box padding={3} px={8}>
      <Typography variant="h3">Bulk Upload</Typography>
      <Box sx={{ borderBottom: 1, borderColor: "divider", marginBottom: 5 }}>
        <Tabs
          value={tab}
          onChange={handleTabChange}
          sx={{
            ">.MuiTabs-scroller": {
              ">.MuiTabs-indicator": {
                backgroundColor: theme.palette.common.black,
              },

              ">.MuiTabs-flexContainer>.Mui-selected": {
                fontWeight: 600,
                color: theme.palette.common.black,
              },
            },
          }}
        >
          {hasBulkUploadAccess && (
            <Tab
              label={bulkUploadTabs.DOCUMENT_UPLOAD}
              value={bulkUploadTabs.DOCUMENT_UPLOAD}
            />
          )}
          {hasBulkUploadStatusHistoryAccess && (
            <Tab
              label={bulkUploadTabs.BULK_UPLOAD_STATUS_HISTORY}
              value={bulkUploadTabs.BULK_UPLOAD_STATUS_HISTORY}
            />
          )}
        </Tabs>
      </Box>
      {hasBulkUploadAccess && (
        <TabPanel value={bulkUploadTabs.DOCUMENT_UPLOAD} selectedTab={tab}>
          <DocumentUpload />
        </TabPanel>
      )}
      {hasBulkUploadStatusHistoryAccess && (
        <TabPanel
          value={bulkUploadTabs.BULK_UPLOAD_STATUS_HISTORY}
          selectedTab={tab}
        >
          <BulkUploadStatusHistory />
        </TabPanel>
      )}
    </Box>
  );
};

export default BulkUpload;
